import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "cobain_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const adminApi = axios.create({ baseURL: BASE });
adminApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${process.env.REACT_APP_BACKEND_URL}/api/media/${p}`);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
